declare const zE: any;

const handleZendeskWidget = (isAuthenticated: boolean) => {
	if (isAuthenticated) {
		const userInfo = JSON.parse(window.localStorage.getItem('UserData'));
		const prefillObj = {
			email: {
				value: `${userInfo.user.email}`,
			},
			name: {
				value: `${userInfo.user.firstName} ${userInfo.user.lastName}`,
			},
		};
		zE('webWidget', 'prefill', prefillObj);
	} else {
		zE('webWidget', 'reset');
	}
};

export { handleZendeskWidget };



// WEBPACK FOOTER //
// ./src/handle-zendesk.ts